import { h } from '@stencil/core';
import cn from 'classnames';
import { EnvironmentalGroup } from './environmental-group-container';
export class EnvironmentalCharacteristics {
  constructor() {
    this.showViewMore = () => {
      var _a, _b;
      const wrapperHeight = (_a = this.envCharacteristicsRef.shadowRoot
        .querySelector('.envsection__characteristics')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
      const contentHeight = (_b = this.envCharacteristicsRef.shadowRoot
        .querySelector('.envsection__table')) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height;
      return contentHeight > wrapperHeight;
    };
    this.groups = undefined;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.isMobile = undefined;
    this.areTestsRunning = false;
    this.showViewMoreLabel = false;
    this.isExpanded = false;
    this.envCharacteristicsRef.dir = document.documentElement.dir || 'auto';
  }
  handleToggleViewMore(e) {
    this.isExpanded = e.detail;
  }
  componentDidLoad() {
    if (!this.groups || !this.envCharacteristicsRef || this.areTestsRunning)
      return;
    setTimeout(() => {
      this.showViewMoreLabel = this.showViewMore();
    }, 1000);
  }
  windowSizeDidChange() {
    if (!this.groups || !this.envCharacteristicsRef || this.areTestsRunning)
      return;
    this.showViewMoreLabel = this.showViewMore();
  }
  render() {
    if (!this.groups)
      return null;
    return (h("div", { class: cn({ 'envsection__characteristics-wrapper': true,
        'envsection__characteristics-wrapper_expanded': this.isExpanded }) }, h("div", { class: "envsection__characteristics" }, h("div", { class: "envsection__table" }, this.groups.map((group) => h(EnvironmentalGroup, Object.assign({}, group))))), this.isMobile && this.showViewMoreLabel && (h("pes-view-more-link", { viewMoreLabel: this.showMoreLabel, viewLessLabel: this.showLessLabel, isExpanded: this.isExpanded, class: 'envsection__view-more' }))));
  }
  static get is() { return "pes-environmental-characteristics"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["environmental-characteristics.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["environmental-characteristics.css"]
    };
  }
  static get properties() {
    return {
      "groups": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TEnvironmentalGroup[]",
          "resolved": "TEnvironmentalGroup[]",
          "references": {
            "TEnvironmentalGroup": {
              "location": "import",
              "path": "../environmental-data/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-less-label",
        "reflect": false
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      },
      "areTestsRunning": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "are-tests-running",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "showViewMoreLabel": {},
      "isExpanded": {}
    };
  }
  static get elementRef() { return "envCharacteristicsRef"; }
  static get listeners() {
    return [{
        "name": "didToggleViewMore",
        "method": "handleToggleViewMore",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
